// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { AdjustInventoryContext } from '@/items/contexts/adjust-inventory-context';
import { useContext } from 'react';

/**
 * Hook to access the adjust inventory context.
 */
export function useAdjustInventory() {
  const context = useContext(AdjustInventoryContext);

  if (!context) {
    throw new Error(
      'useAdjustInventory must be used within an AdjustInventoryProvider'
    );
  }

  return context;
}
